module.exports = {
	"adobeSwfUrl": "/tools/swf/cvp/AccessEnablerLoader.swf",
	"clientId": "AdultSwim",
	"mvpdConfigUrl": "http://z.cdn.turner.com/xslo/cvp/config/as/tve/mvpdconfig.js",
	"refreshlessLogin": true,
	"refreshlessLogout": true
};


//////////////////
// WEBPACK FOOTER
// ./src/common/config/cvp-auth.json
// module id = 174
// module chunks = 1 2